import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { setBecome, storeSelectedSubscriptions } from "../../sagas/actions";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  font-family: Arial, sans-serif, verdana, helvetica;
  font-size: 90%;
  margin: 0;
  background: #2c4960;
  text-align: right;
  padding: 7px 20px;
  font-weight: bold;
`;

const Link = styled.a`
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default function ZoomOut() {
  const dispatch = useDispatch();
  const origin = useSelector((state) => state.auth.become_origin);
  const navigate = useNavigate();
  const handleZoom = () => {
    dispatch(storeSelectedSubscriptions({}));
    dispatch(setBecome(0));
    if (origin === "directory") {
      navigate('/admincentral/orgs/search', { state: { initialTab: "User Search" } });
    } else {
      navigate('/admincentral/subscriptions/search');
    }
  }
  return (
    <Container>
      <Link onClick={() => handleZoom()}>Zoom out</Link>
    </Container>
  );
}
